var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedicineExclamation = function SvgMedicineExclamation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9341 7.99438H3V19.9831C3 21.3152 3.66667 21.9813 5 21.9813C5.80072 21.9838 6.56805 21.986 7.30198 21.988C6.9018 21.0931 6.87348 20.0194 7.37379 19.0267L12.9341 7.99438Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6V3.99813C2 2.66604 2.67918 2 4.03754 2H20C21.3333 2 22 2.66604 22 3.99813V6H2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.066 7.99438L21 11.8318V7.99438H19.066Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 19.9341L14.6169 8.74754C15.1299 7.72584 16.5636 7.72584 17.0766 8.74754L22.6934 19.9341C23.1634 20.8701 22.4959 21.9813 21.4636 21.9813H10.2298C9.19755 21.9813 8.53002 20.8701 9 19.9341ZM14.372 19.235C14.372 18.4581 14.9904 17.8283 15.7533 17.8283C16.5161 17.8283 17.1346 18.4581 17.1346 19.235C17.1346 20.0119 16.5161 20.6418 15.7533 20.6418C14.9904 20.6418 14.372 20.0119 14.372 19.235ZM16.7892 12.2014C16.7892 11.6187 16.3254 11.1464 15.7533 11.1464C15.1811 11.1464 14.7173 11.6187 14.7173 12.2014V15.7182C14.7173 16.3009 15.1811 16.7733 15.7533 16.7733C16.3254 16.7733 16.7892 16.3009 16.7892 15.7182V12.2014Z",
    fill: "#E76F00"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedicineExclamation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medicine-exclamation.582c1201.svg";
export { ForwardRef as ReactComponent };